import { authRoleAccess } from "auth/AuthRoleAccess";
import { lazy } from "react";

const FirstRespondentLeadCaseView = lazy(() => import("./FirstRespondentLeadCaseView.jsx"));
const CaseSingleCaseView = lazy(() => import("./CaseSingleCaseView.jsx"))

const FirstRespondentLeadCaseViewRoutes = [
  {
    path: "/first-respondent-lead-case",
    component: FirstRespondentLeadCaseView,
    auth: authRoleAccess.first_respondent_lead_case_view,
  },
  {
      path: "/first-respondent-lead/cases/:id",
      component: CaseSingleCaseView,
      auth: authRoleAccess.first_respondent_lead_case_view,
    },
];

export default FirstRespondentLeadCaseViewRoutes;